// src/components/common/Button/Button.jsx
import React from 'react';
import '../../../assets/css/components/general/button/Button.css';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  fullWidth = false,
  icon = null,
  iconPosition = 'left',
  onClick,
  disabled = false,
  className = '',
  type = 'button',
  props 
}) => {
  
  const buttonClasses = [
    'custom-btn',
    `custom-btn-${variant}`,
    `custom-btn-${size}`,
    fullWidth ? 'custom-btn-full' : '',
    disabled ? 'custom-btn-disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon && iconPosition === 'left' && (
        <span className="custom-btn-icon custom-btn-icon-left">{icon}</span>
      )}
      
      <span className="custom-btn-text">{children}</span>
      
      {icon && iconPosition === 'right' && (
        <span className="custom-btn-icon custom-btn-icon-right">{icon}</span>
      )}
    </button>
  );
};

export default Button;